export default {
    finalize() {
        jQuery('#guest-button').on('click', function(e) {
            $(this).hide().parent().removeClass('md:flex-row');
            $('.hide_on_guest_registration').hide();
            $('#guest').show();
            return false;
        });
    }
};
